import iconAbTest from '@modules/JourneyBuilder/Assets/Bricks/icon-ab-test.svg?component';
import iconAudienceFilter from '@modules/JourneyBuilder/Assets/Bricks/icon-audience-filter.svg?component';

import {brickDefinitions} from "./brick-definitions";
import brickTypes from './brick-types';

const getBrickIconClass = (brickType, brickConfig) => {
    brickConfig = brickConfig || {};
    return brickConfig.icon != null ? brickConfig.icon :  brickDefinitions[brickType].icon;
};

const getBrickIconSvg = brickType => {
    switch (brickType){
        case brickTypes.audienceFilter:
            return iconAudienceFilter;
        case brickTypes.abTest:
            return iconAbTest;
        default: 
            return undefined;
    }
}

export {
    getBrickIconClass,
    getBrickIconSvg
}
